import React, { useEffect, useState } from "react";
import {default as ProfileSettingsForm} from '../components/Profile/ProfileSettings.tsx';
import { useProfileApi } from "../features/auth/hooks/use-profile-api.ts";
import { IProfile } from "../interface/IProfile.ts";
import { ApiResponseType } from "../features/api/types.ts";
import ApiCheck from "../components/Structure/ApiCheck.tsx";

export default function ProfileSettings() {
    const [profile, setProfile] = useState<IProfile|any>({});
    const [profileIsLoading, setProfileIsLoading] = useState(true);
    const [apiErrors, setApiErrors] = useState<any>();
    const { getProfile } = useProfileApi();
    useEffect(() => {
        getProfile().then(data => {
            if (data.type === ApiResponseType.OK) {
                setProfile(data.payload);
            } else {
                setApiErrors(data.payload);
            }
            setProfileIsLoading(false);
        })
    },[]);

    if (profileIsLoading) {
        return (<div className="loader"></div>);
    }

    return (
        <div id="profile-settings">
            <ApiCheck errors={apiErrors ? apiErrors.errors : null}>
                <h1 className="h3">Kontoeinstellungen</h1>
                <ProfileSettingsForm profile={profile} setProfile={setProfile} />
            </ApiCheck>
        </div>
    )
}